import Config from './messages';
import {
    createDateTimeObject
} from "./shared/functions";

/**
 * Intercept resources that attempt to load data before a filter value is available
 *
 * @param resource
 * @param type
 * @param params
 *
 * @return boolean
 */
export const interceptLoadData = (type, resource, params) => {
    if (resource === 'POSKits' && type === 'GET_LIST') {
        if (
            !params.filter.filter_by ||
            (params.filter.filter_by === 'filter_dba' && !params.filter.filter_dba) ||
            (params.filter.filter_by === 'filter_district' && !params.filter.filter_district) ||
            (params.filter.filter_by === 'filter_kit_id' && !params.filter.filter_kit_id) ||
            (params.filter.filter_by === 'filter_location' && !params.filter.filter_location)
        ) {
            return true;
        }
    }
    if (resource === 'Locations' && type === 'GET_LIST') {
        if (
            !params.filter.filter_by ||
            (params.filter.filter_by === 'filter_company' && !params.filter.filter_company) ||
            (params.filter.filter_by === 'filter_dba' && !params.filter.filter_dba) ||
            (params.filter.filter_by === 'filter_district' && !params.filter.filter_district) ||
            (params.filter.filter_by === 'filter_location' && !params.filter.filter_location) ||
            (params.filter.filter_by === 'filter_state' && !params.filter.filter_state)
        ) {
            return true;
        }
    }
    if (resource === 'Products' && type === 'GET_LIST') {
        if (
            params.filter.search_name_submit &&
            params.filter.search_name &&
            (
                params.filter.search_name === '' ||
                params.filter.search_name.length < 3
            )
        ) {
            return true;
        } else if (!params.filter.search_name_submit) {
            if (!params.filter.type) {
                return true;
            } else if (params.filter.type && !params.filter.category_id) {
                return true;
            }
        }
    }
    if (
        (resource === 'ProductCategories' && type === 'GET_LIST') ||
        (resource === 'ProductUnits' && type === 'GET_LIST')
    ) {
        if (!params.filter.type) {
            return true;
        }
    }
    if (resource === 'ProductAliases' && type === 'GET_LIST') {
        if (!params.filter.type || !params.filter.unit_type) {
            return true;
        }
    }
    if (resource === 'LocationInventory' || resource === 'InventoryTransfers') {
        if (type === 'GET_LIST') {
            if (!params.filter.location_id_select && !params.filter.location_id_text) {
                return true;
            }
        }
    }
    if (resource === 'InventoryTransferAudits' && type === 'GET_LIST') {
        if (!params.filter.date_from || !params.filter.date_to || !params.filter.offset) {
            return true;
        }
    }
    if (resource === 'InventoryRepacksRetailBoxes' && type === 'GET_LIST') {
        if (!params.filter.collection_id) {
            return true;
        }
    }
    if (resource === 'LoyaltyAccounts' && type === 'GET_LIST') {
        if (!params.filter.loyalty_id && !params.filter.loyalty_email && !params.filter.loyalty_telephone) {
            return true;
        }
    }
    if (resource === 'LoyaltyAccountLogs' && type === 'GET_LIST') {
        if (!params.filter.loyalty_lock) {
            return true;
        }
    }
    if (resource === 'POSUsers' && type === 'GET_LIST') {
        if (!params.filter.filter_by ||
            (params.filter.filter_by === 'filter_location' && !params.filter.filter_location) ||
            (params.filter.filter_by === 'filter_level' && !params.filter.filter_level)
        ) {
            return true;
        }
    }
    return false;
};

/**
 * Create a payload object for upsert functions
 *
 * @param resource
 * @return {{payload: {}}}
 */
export const createUpsertPayload = (resource) => {
    // Create payload object
    let payloadObj = {
        "client": {
            system: localStorage.getItem('system'),
            location: Config.fuse.client.location,
            register: Config.fuse.client.register,
            user: localStorage.getItem('email'),
            device: Config.fuse.client.device,
            version: Config.fuse.admin.version
        },
        "payload": {},
        "pkg_date_time": createDateTimeObject(),
        "pkg_uuid": "",
        "pkg_version": 4,
    };

    // Create payload children according to upsert resource

    if (resource === 'InventoryTransfers' || resource === 'InventoryRepacksRetailBoxes') {
        // Transfers and Repacks/Retail Boxes do not use a "payload.model"
    } else {
        // All other resources use payload.model
        payloadObj.payload.model = {};
    }
    return payloadObj;
};

/**
 * Customize a payload object for upsert functions
 *
 * @param type
 * @param resource
 * @param dataObj
 */
export const assignPayload = (type, resource, dataObj) => {
    let payload = {};
    if (resource === 'InventoryTransfers' && type === 'CREATE') {
        // Transfers populate invItemDataModel and transfer_items
        payload.invItemDataModel = dataObj;
    } else if (resource === 'InventoryRepacksRetailBoxes' && type === 'UPDATE') {
        // Repacks/Retail Boxes populate invCollectionModel and contents
        payload.invCollectionModel = dataObj;
    } else {
        // All other resources populate a model
        payload.model = dataObj;
    }
    return payload;
};



// WEBPACK FOOTER //
// ./src/Fuse/restClientPreProcess.js